import { useNavigate } from "react-router-dom";
import buildVersion from "@/buildVersion.json";

/**
 * Tiny, low-contrast version pill. Clickable — routes to /admin/version-debug.
 * Deliberately understated so it's available for ops triage without distracting users.
 */
export default function VersionPill({ style = {} }) {
  const navigate = useNavigate();
  const v = buildVersion?.version || "";
  if (!v) return null;
  return (
    <button
      data-testid="version-pill"
      onClick={() => navigate("/admin/version-debug")}
      title={`Bundle ${v} — tap for diagnostics`}
      style={{
        background: "transparent",
        border: "none",
        padding: 0,
        margin: 0,
        cursor: "pointer",
        fontSize: 10,
        lineHeight: 1.1,
        color: "#9CA3AF",
        fontFamily: "ui-monospace, SFMono-Regular, Menlo, monospace",
        opacity: 0.7,
        letterSpacing: "0.02em",
        ...style,
      }}
    >
      v.{v}
    </button>
  );
}
